/**
 * @class RangeBar
 * @description
 * フォームのinput type="range"の見た目をカスタマイズ
 *  バーの色を変更し、つまみの上に現在値を表示
 */

export default class RangeBar{
  constructor() {
    const rangeSliders = document.querySelectorAll('.range-bar');
    if(!rangeSliders) return;

    this.baseColor = '#442A19'; //茶色
    this.activeColor = '#F78072'; //オレンジ

    rangeSliders.forEach((slider) => {
      let currentValueText = slider.querySelector('.range-bar__current span');
      let input = slider.querySelector('input[type="range"]');
      this.matchCurrent(input, currentValueText);
      input.addEventListener('input', (e) => {
        this.updateSlider(e.target, currentValueText);
        this.matchCurrent(e.target, currentValueText);
      });
      this.updateSlider(input);
    });
  }

  /**
   * 現在値までのバーのカラーを更新
   * @param {HTMLElement} slider - 更新するバー要素
   */
  updateSlider(slider) {
    if (!slider.max) {
      slider.max = 10;
    }
    const progress = (slider.value / slider.max ) * 100 - (slider.max -1* slider.value);
    slider.style.background = `linear-gradient(to right, ${this.activeColor} ${progress}%, ${this.baseColor} ${progress}%)`;
  }

  /**
   * つまみの上に現在値を表示
   *
   * @param {HTMLInputElement} input - 入力要素
   * @param {HTMLElement} currentext - 現在の値を表示する要素
   */
  matchCurrent(input, currentext) {
    let number = input.value;
    let max = input.max;
    const current = parseInt(number);

    const ratio = ((current) / (10) ) * 100 - max + current * 0.5;
    let digitCount = number.toString().length;
    if (digitCount === 1) {
      currentext.style.marginLeft = '0';
    } else if (digitCount === 2) {
      //２桁の時はマージンを調整
      currentext.style.marginLeft = '-0.35em';
    }
    currentext.style.left = ratio + '%';
    currentext.innerText = current;
  }
}
